module.exports = __webpack_public_path__ + "img/Frame 135.d782b7e6.png";